// extracted by mini-css-extract-plugin
export default {"rules__icon":"styles_rules__icon__mBrqg","rules__modal":"styles_rules__modal__wgP7h","rules__modal__text":"styles_rules__modal__text__uNx8W"};